import {
  getEmployees,
  getEmployeeInfo,
  getPriceInfo,
  getLastUserPrice,
  getEmployeePastInfo,
  // getEmployeeFutureInfo,
  getAllEmployeesInfo,
  createEmployee,
  updateEmployee
} from '../api/employees.js';

export default {
  state: {
    employee: null,
    price: [],
    lastPrice: [],
    employees: [],
    employeesInfo: [],
    pastInfo: [],
    futureInfo: [],
    monitoring: [],
    newEntity: null
  },
  mutations: {
    getEmployees(state, employees) {
      state.employees = employees;
    },
    getEmployeeInfo(state, employee) {
      state.employee = employee;
    },
    getPriceInfo(state, price) {
      state.price = price;
    },
    getLastUserPrice(state, lastPrice) {
      state.lastPrice = lastPrice;
    },
    getEmployeePastInfo(state, pastInfo) {
      state.pastInfo = pastInfo;
    },
    // getEmployeeFutureInfo(state, futureInfo) {
    //   state.futureInfo = futureInfo;
    // },
    getAllEmployeesInfo(state, employeesInfo) {
      state.employeesInfo = employeesInfo;
    },
    createEmployee(state, employee) {
      state.newEntity = employee;
    },
    updateEmployee(state, employee) {
      state.newEntity = employee;
    }
  },
  actions: {
    async getEmployees({ commit }) {
      const response = await getEmployees();
      response.forEach(e =>
        e.name = (([firstName, ...rest]) => [firstName, rest.join(" ").toUpperCase()].join(" "))(e.name.split(" "))
      );
      commit("getEmployees", response);
    },
    async getEmployeeInfo({ commit }, id) {
      const response = await getEmployeeInfo(id);
      commit("getEmployeeInfo", response);
    },
    async getPriceInfo({ commit }, params) {
      const response = await getPriceInfo(params);
      commit("getPriceInfo", response);
    },
    async getLastUserPrice({ commit }, params) {
      const response = await getLastUserPrice(params);
      console.log(response);
      commit("getLastUserPrice", response);
    },
    async getEmployeePastInfo({ commit, dispatch }, params) {
      try {
        const response = await getEmployeePastInfo(params);
        commit("getEmployeePastInfo", response);
        return response;
      } catch (error) {
        if (error.message.message.includes("bad decrypt")) {
          dispatch("setToastMessage", {
            message: `Mot de passe invalide`
          });
          dispatch("setToastMode", { mode: "error" });
          dispatch("setOpenToast", { opened: true });
        } else {
          dispatch("setToastMessage", { message: "errorOccured" });
          dispatch("setToastMode", { mode: "error" });
          dispatch("setOpenToast", { opened: true });
        }
        return;
      }
    },
    // async getEmployeeFutureInfo({ commit, dispatch }, params) {
    //   try {
    //     const response = await getEmployeeFutureInfo(params);
    //     commit("getEmployeeFutureInfo", response);
    //     return response;
    //   } catch (error) {
    //     console.log(error);
    //     if (error.message.message.includes("bad decrypt")) {
    //       dispatch("setToastMessage", {
    //         message: `Mot de passe invalide`
    //       });
    //       dispatch("setToastMode", { mode: "error" });
    //       dispatch("setOpenToast", { opened: true });
    //     } else {
    //       dispatch("setToastMessage", { message: "errorOccured" });
    //       dispatch("setToastMode", { mode: "error" });
    //       dispatch("setOpenToast", { opened: true });
    //     }
    //     return;
    //   }
    // },
    async getAllEmployeesInfo({ commit, dispatch }, password) {
      try {
        const response = await getAllEmployeesInfo(password);
        commit("getAllEmployeesInfo", response);
        return response;
      } catch (error) {
        if (error.message.message.includes("bad decrypt")) {
          dispatch("setToastMessage", {
            message: `Mot de passe invalide`
          });
          dispatch("setToastMode", { mode: "error" });
          dispatch("setOpenToast", { opened: true });
        } else {
          dispatch("setToastMessage", { message: "errorOccured" });
          dispatch("setToastMode", { mode: "error" });
          dispatch("setOpenToast", { opened: true });
        }
        return;
      }
    },
    async createEmployee({ commit, dispatch }, data) {
      try {
        const response = await createEmployee(data);
        commit("createEmployee", response);
        return response;
      } catch(error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          case "SequelizeUniqueConstraintError":
            dispatch("setToastMessage", {
              message: `Des données ont déjà été enregistrées à cette date`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
        }
        return;
      }
    },
    async updateEmployee({ commit, dispatch }, data) {
      try {
        const response = await updateEmployee(data);
        commit("updateEmployee", response);
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          case "SequelizeUniqueConstraintError":
            dispatch("setToastMessage", {
              message: `Le projet existe déjà`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
        }
        return;
      }
    },
  }
}